module.exports = __webpack_public_path__ + "static/media/YB5F05_1.9f7aef2b.jpg";